export default function formatPrice(n) {
  const isInt = n % 1 === 0;
  const roundUp = (n) => parseFloat(n.toFixed(3).slice(0, -1));
  const rounded = isInt ? n : roundUp(n);

  return rounded.toLocaleString('en-US'); // add comma if rounded > 999
}
